import { createContext, useContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { useAuthStore } from 'providers/AuthStoreProvider'
import RootStore from 'stores/RootStore'

const RootStoreContext = createContext(null)

const RootStoreProvider = observer(({ children }) => {
    const authStore = useAuthStore()
    // Recreate session stores on login/logout so listing caches never leak across users
    const isAuthenticated = Boolean(authStore.authUser)

    const rootStore = useMemo(() => new RootStore(authStore), [authStore, isAuthenticated])

    return <RootStoreContext.Provider value={rootStore}>{children}</RootStoreContext.Provider>
})

RootStoreProvider.propTypes = {
    children: PropTypes.element.isRequired,
}

const useRootStore = () => useContext(RootStoreContext)

// eslint-disable-next-line import/prefer-default-export
export { RootStoreProvider, useRootStore, RootStoreContext }
